<div class="chart-wrapper">
    <h3>Dziękujemy za oddany głos!</h3>
    <h4>Wyniki ankiety</h4>
    <canvas #canvas></canvas>
</div>